import React from "react"
import { SkeletonElement } from "components/skeleton/SkeletonElement"
import { KenticoImageLink } from "components/image-link/image-link"
import { KenticoSingleImage } from "components/image/single-image"
import "./testimonial.module.scss"
import { Button } from "components/button"

interface TestimonialBannerProps {
  backgroundImageUrl?: string
  children: React.ReactNode
  googleReviewUrl?: string
  hasFieldroutesReviews?: boolean
  hasReviewLoaded?: boolean
  heading?: string
  socialLogos?: (KenticoImageLink | KenticoSingleImage)[]
  subHeading?: string
  hasSliderWithNavigation?: boolean
}

export const TestimonialBanner = ({
  // backgroundImageUrl,
  // googleReviewUrl,
  // socialLogos,
  children,
  hasFieldroutesReviews = false,
  hasReviewLoaded = true,
  // hasSliderWithNavigation = false,
  heading,
  subHeading,
}: TestimonialBannerProps) => {
  return (
    <section
      className={`fr-testimonial u-content-block-padding ${
        hasFieldroutesReviews ? "fr-testimonial--fadeIn" : ""
      }`}
    >
      <div className="fr-container fr-container--large fr-testimonial__wrapper">
        {heading && (
          <div className="u-container-header">
            <h2>{heading}</h2>
            {subHeading && <h3>{subHeading}</h3>}
          </div>
        )}

        <div className="fr-container fr-container--small fr-testimonial__body-container">
          {children}
        </div>

        {hasFieldroutesReviews && !hasReviewLoaded && (
          <SkeletonElement
            type="text"
            additionalClassNames={"fr-testimonial-skeleton__button"}
          />
        )}

        {hasFieldroutesReviews && hasReviewLoaded && (
          <Button
            to="/reviews"
            variant="outline-secondary"
            extraClassNames="fr-testimonial__cta-button"
          >
            View More Testimonials
          </Button>
        )}
      </div>
    </section>
  )
}
